import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WINDOW } from '@core/constants';
import { PortalThemeColors } from '@core/theme/theme.interfaces';
import { ThemeService } from '@iq-angular-libs/portal';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BasispreisBase } from '../share/basispreis-base/basispreis-base';
import { BasispreisData } from '../share/widgets.interfaces';
import { WidgetsService } from '../share/widgets.service';

@Component({
  selector: 'iq-basispreis-sauen-widget',
  templateUrl: './basispreis-sauen-widget.component.html',
  styleUrls: ['./basispreis-sauen-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BasispreisSauenWidgetComponent extends BasispreisBase implements OnInit {
  /**
   * Constructor
   * @param window The injected window object.
   * @param translate {@link TranslateService}
   * @param themeService {@link ThemeService}
   * @param widgetsService {@link WidgetsService}
   */
  constructor(
    @Inject(WINDOW) window: Window,
      translate: TranslateService,
      themeService: ThemeService<PortalThemeColors>,
    protected widgetsService: WidgetsService
  ) {
    super(window, translate, themeService, widgetsService);
    this.lineChartOptions.chartId = 'basispreis-sauen-chart';
  }

  /**
   * Triggers the fetching of the data
   */
  ngOnInit() {
    super.ngOnInit();
    this.getData();
  }

  /**
   * Retrieves the base price data for the sows.
   */
  protected getBasispreisData(): Observable<BasispreisData> {
    return this.widgetsService.getBasispreisSauenWidgetData();
  }
}
